export const categories = [
  {
    slug: 'chan-yi-gu-shi',
    name: '禅意故事',
    description: '草灯和尚的禅意故事，以草木为媒，讲述东方智慧与心灵修行。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'xiu-xing-zhe-xue',
    name: '修行哲学',
    description: '探索草灯和尚的修行哲学，体悟禅宗心法与人生智慧。',
    icon: 'ri-plant-line',
  },
  {
    slug: 'sheng-huo-mei-xue',
    name: '生活美学',
    description: '融入草灯和尚的生活美学，在日常中品味东方诗意栖居。',
    icon: 'ri-cup-line',
  },
  {
    slug: 'yi-shu-xing-xiang',
    name: '艺术形象',
    description: '草灯和尚的艺术形象解析，感受传统与当代的文化交融。',
    icon: 'ri-palette-line',
  },
  {
    slug: 'xian-dai-chuan-cheng',
    name: '现代传承',
    description: '草灯和尚的文化传承，在当代社会中延续禅意精神。',
    icon: 'ri-ancient-gate-line',
  },
];